import gsap, { TimelineMax, TweenMax } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
import ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import stickyfill from 'stickyfilljs';
import FlexiblesInit from './Flexibles';
import './Polyfills.js';
import { BrevoFormCaptcha } from './class/BrevoFormCaptcha';
import Menu from './class/Menu';
import { Modal } from './class/Modal';
import ScrollMagicController from './class/ScrollMagicController.js';
import Sellsy from './class/Sellsy';
import { scrollToElement, scrollToTarget } from './utils/functions.js';
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
require('./utils/prototypes');

gsap.registerPlugin(ScrollToPlugin);

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

class App {
	constructor() {
		this.addScrollToOnSamePageLinks();

		if (window.location.href.indexOf('#') > -1) {
			const anchorID = window.location.href.split('#').pop().split('?').shift();

			if (anchorID && document.getElementById(anchorID)) {
				scrollToTarget(`#${anchorID}`);
			}
		}

		new Sellsy();
		new BrevoFormCaptcha();

		FlexiblesInit();

		this.revealManager();

		//Navigation
		this.menu = new Menu();
		// this.activeModal();
		this.addFocusListeners();

		var elements = document.querySelectorAll('.sticky-navigation');
		stickyfill.add(elements);

		document.querySelectorAll('[data-scrollto]').forEach((el) => el.addEventListener('click', scrollToElement));

		document.querySelectorAll('.button--popup').forEach((element) => {
			new Modal(element.querySelectorAll('.cta'), element.querySelector('.modal'));
		});
	}

	revealManager() {
		let _this = this;

		document.querySelectorAll('[gsap-reveal]').forEach((el) => {
			let tween = TweenLite.fromTo(el, 1, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Quad.easeOut });

			let scene = new ScrollMagic.Scene({ triggerElement: el, triggerHook: 0.85, duration: window.clientHeight / 3 })
				.setTween(tween)
				.addTo(ScrollMagicController.controller);

			_this.scenes.push(scene);
		});
	}

	activeModal() {
		const modal = document.getElementById('contact-modal');
		const btn = document.querySelector('.menu .modal a');
		const closeBtn = modal.querySelector('.close');
		const tab = modal.querySelectorAll('.tab__header');

		if (modal) {
			if (btn) {
				btn.addEventListener('click', function () {
					modal.style.display = 'block';
				});
			}

			if (closeBtn) {
				closeBtn.addEventListener('click', function () {
					modal.style.display = 'none';
				});
			}

			window.addEventListener('click', function (event) {
				if (event.target == modal) {
					modal.style.display = 'none';
				}
			});

			if (tab.length) {
				for (let i = 0; i < tab.length; i++) {
					tab[i].addEventListener(
						'click',
						function (event) {
							const tabsGroup = document.querySelector('.tabs-group');
							const tabsContent = document.querySelectorAll('.tab__content');

							for (let i = 0; i < tab.length; i++) {
								tab[i].classList.remove('active');
							}

							for (let i = 0; i < tabsContent.length; i++) {
								tabsContent[i].classList.remove('active');
							}
							event.target.classList.add('active');
							let classString = event.target.getAttribute('data-target');
							document.getElementById('panels').getElementsByClassName(classString)[0].classList.add('active');
						},

						false
					);
				}
			}
		}
	}

	addFocusListeners() {
		this.fields = document.querySelectorAll('input, textarea');
		this.fields.forEach((field) => {
			// Removes error class on focus
			field.addEventListener('focus', function (e) {
				this.classList.remove('error');
			});

			// Checks if the field is empty on blur
			field.addEventListener('blur', function (e) {
				if (this.value != '') {
					this.classList.remove('empty');
					this.classList.add('not-empty');
				} else {
					this.classList.remove('not-empty');
					this.classList.add('empty');
				}
			});
		});
	}

	addScrollToOnSamePageLinks() {
		const links = document.querySelectorAll('a[href^="#"]');

		links.forEach((link) => {
			link.addEventListener('click', function (ev) {
				ev.stopPropagation();
				ev.preventDefault();

				const { href } = ev.target;

				const anchorID = href.split('#').pop().split('?').shift();

				if (anchorID && document.getElementById(anchorID)) {
					scrollToTarget(`#${anchorID}`);
				}
			});
		});
	}
}

// const swup = new Swup();
document.addEventListener('DOMContentLoaded', function (ev) {
	new App();
	// swup.on('transitionStart', () => {
	// 	const videos = document.querySelectorAll('video');
	// 	if (videos.length) {
	// 		videos.forEach((video) => video.pause());
	// 	}
	// });
	// swup.on('contentReplaced', () => {
	// 	// Lorsqu'on change de page, on reviens tout en haut.
	// 	window.scrollTo(0, 0);
	// 	ScrollMagicController.reset();
	// 	new App(false);
	// });
});

// export { swup };
